import { render } from "./employee_information_tab.vue?vue&type=template&id=23369bb7"
import script from "./employee_information_tab.vue?vue&type=script&lang=js"
export * from "./employee_information_tab.vue?vue&type=script&lang=js"

import "./employee_information_tab.vue?vue&type=style&index=0&id=23369bb7&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__